import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ContactHero from "./components/ContactHero";
import ContactIntro from "./components/ContactIntro";
import InquiryOptions from "./components/InquiryOptions";
import ContactForm from "./components/ContactForm";
import ConsultationSection from "./components/ConsultationSection";
import LocationReach from "./components/LocationReach";
import NewsletterSignup from "./components/NewsletterSignup";
import ContactFAQ from "./components/ContactFAQ";
import ContactCTA from "./components/ContactCTA";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />
      <main>
        <ContactHero />
        <ContactIntro />
        <InquiryOptions />
        <ContactForm />
        <ConsultationSection />
        <LocationReach />
        <NewsletterSignup />
        <ContactFAQ />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}
